import {
  SET_ORDER_COMPLETE_ACTION
} from '../constants';
import {GetOrderDetail} from './orderActions';
import {holdOrderItemNotFulfilled} from '../services/scanpackApiService';
import { clearBoxChampConfirmationTimer, refuseRestartAwaitingLastSeal } from './boxChampGuidedNotices';
import {
  resetBoxChampCatalogRequest,
  resetBoxChampPlanRequest,
  runGuidedScanPrelude,
  guidedRefusesItemScan,
  guidedRefusesScanAll,
  recordGuidedNotFulfilled
} from './boxChampGuidedActions';
import stampGuidedLog from '../components/ScanpackScanning/utils/boxChampGuidedLog';
import { getGuidedView, boxChampOf } from '../components/ScanpackScanning/utils/boxChampGuidedSelectors';
export * from './scanpackScanningSetters';
export * from './productAliasActions';
export * from './multiBoxActions';
export * from './shipmentActions';
export * from './orderPromptActions';
export * from './addItemActions';
export * from './submitLogThrottle';
export * from './postScanActions';
export * from './boxChampGuidedActions';
export * from './boxChampGuidedNotices';
import {
  setScanPackCurrentOrder,
  setScanPackCurrentItem,
  setCurrentItem,
  shuffleToItem,
  setScanPackBarcodeInput,
  setScanPackMainInputFocus,
  setScanPackPrompt,
  setScanPackScanSuccess,
  setScanPackScanError,
  setOrderComplete,
  setPostScanPipeline,
  setTypeScanState,
  setTypeScanAdjacentScans,
  closePrompt,
  handleInputFocus,
  handleNotReady,
  getStateValues,
  addLocalLog,
  navigateBack,
  setScanPackLoadingState,
  setWmsZeroPending,
  clearWmsZeroPending,
  resetBoxChampState,
  setBoxChampState
} from './scanpackScanningSetters';
import { resolveMultiBoxContext, handleBoxNavigation, removeBoxItem } from './multiBoxActions';
import { resetSubmitLogThrottle, saveAndSubmitLog, submitQueuedLogsBounded } from './submitLogThrottle';
import { handleOrderComplete, holdGuidedCompletion } from './postScanActions';
import {SearchScanpackOrder} from './scanpackAction';
import {SubmitLog, submitGatedScan, submitGatedZeroScan, waitForSubmitIdle} from './saveLogAction';
import {ClearSearchProduct} from './productAction';
import {navigate} from '../components/root_navigation';
import i18n from 'i18n-js';
import { playSuccessFeedback, playErrorFeedback, playNotReadyFeedback, scanPackSettingsFrom, showsSuccessImage, showsFailImage } from '../utils/scanFeedback';
import {
  getActionBarcodeType,
  checkIsDisabledSkipBarcode,
  usesLowercaseMatching,
  getRestartLog,
  getServiceIssueLog,
  getNoteLog,
  getTypeScanLog,
  getSerialRecordLog,
  getByPassLog,
  getRegularScanLog,
  getRemoveItemLog,
  getWrongScanLog,
  getFirstBarcode,
  removeItem,
  getFirstItem,
  handleTypeScan,
  findItemInAnySequence,
  bulkScanItem,
  buildBulkScanLog,
  getPartialCompleteLog,
  getScannedCompleteLog,
  getSkipLog,
  findDependsChildMatch,
  applyDependsTransformation,
  isKitChildItem,
  checkKitRoundComplete,
  applyKitParentQtyUpdate
} from '../components/ScanpackScanning/utils/scanningUtils';
import {
  processBarcodeInput
} from '../components/ScanpackScanning/utils/barcodeProcessing';
import { initialPostScanPipeline } from '../reducers/scanpackScanningInitialState';
import {
  checkIsValidBarcode,
  updateScannedItemsList,
  updateUnScannedItemsList,
  updateItemQty
} from '../components/scanToCartScanning/utils/scanningUtils';
import { checkClickScanEnabled, checkProductInstructions, checkSerialRecordingEnabled, validateSerialRecord, checkTypeScanCode, nextAdjacentScanCount, quantityAfterScanDeduction, validateConfirmationCode, checkWmsLotVerification, validateWmsLotAnswer, shouldGateForZeroInventory, validateWmsZeroReceiveQty } from '../utils/sharedValidationUtils';
import { saveLogToStorage } from '../utils/logStorageUtils';
import { getItemCounts } from '../components/ScanpackScanning/utils/itemQuantities';
import { getItemToProcess, updateOrderAfterScan, getSuccessTimeout, getFailTimeout, getPackingCount, adjustForPackingCount, addBoxItemToOrder, attachBoxIdToLog } from '../utils/orderHelpers';

const applyDependsTransformAndDispatch = (dispatch, currentOrder, unScannedItems, parentIndex, barcode) => {
  const transformedItems = applyDependsTransformation(unScannedItems, parentIndex);
  const transformedOrder = { ...currentOrder, unscanned_items: transformedItems };
  dispatch(setScanPackCurrentOrder(transformedOrder));
  const lowerBarcode = barcode.toLowerCase();
  const matchedChild = transformedItems[parentIndex].child_items.find(
    c => c.barcodes?.some(b => b.barcode?.toLowerCase() === lowerBarcode)
  );
  dispatch(setScanPackCurrentItem(matchedChild));
  return matchedChild;
};

const resolveItemToScan = (dispatch, processedBarcode, isAnySequence, currentItem, currentOrder, unScannedItems) => {
  if (isAnySequence) {
    const result = findItemInAnySequence(processedBarcode, unScannedItems);
    if (!result) return null;

    if (result.isChildMatch && result.parentItem?.product_type === 'depends') {
      return applyDependsTransformAndDispatch(dispatch, currentOrder, unScannedItems, result.parentIndex, processedBarcode);
    }

    if (result.item !== currentItem) {
      dispatch(shuffleToItem(result.item));
    }
    return result.item;
  }

  if (checkIsValidBarcode(processedBarcode, currentItem)) {
    return currentItem;
  }

  if (unScannedItems[0]?.product_type === 'depends') {
    const childMatch = findDependsChildMatch(processedBarcode, unScannedItems[0]);
    if (childMatch) {
      return applyDependsTransformAndDispatch(dispatch, currentOrder, unScannedItems, 0, processedBarcode);
    }
  }

  return null;
};

export function removeItemFromBox(boxId, orderItemId, productId, kitProductId) {
  return async dispatch => {
    resetSubmitLogThrottle();
    await dispatch(SubmitLog('submitLog'));
    await dispatch(removeBoxItem(boxId, orderItemId, productId, kitProductId));
  };
}

export function reset() {
  return (dispatch, getState) => {
    const leavingGuidedOrder = Boolean(getGuidedView(getState()));
    resetSubmitLogThrottle();
    if (leavingGuidedOrder) dispatch(SubmitLog('submitLog'));
    clearBoxChampConfirmationTimer();
    dispatch(setScanPackCurrentOrder(null));
    dispatch(setScanPackCurrentItem(null));
    dispatch(setScanPackBarcodeInput(''));
    dispatch(setScanPackMainInputFocus(true));
    dispatch(setScanPackPrompt(false, '', '', '', false));
    dispatch(setTypeScanState(''));
    dispatch(setTypeScanAdjacentScans(0));
    dispatch(setOrderComplete(false));
    dispatch({ type: SET_ORDER_COMPLETE_ACTION, payload: false });
    dispatch(setPostScanPipeline({ ...initialPostScanPipeline }));
    // `wmsZeroPending` carries the in-progress Z3 escalation code and lot across chained
    // prompts. The reducer's own doc comment requires it to be cleared on cancel and on
    // successful commit — both of which do so — but reset() runs when the packer LEAVES or
    // reloads the scan screen, which is a third way out of a half-finished prompt. Without
    // this, an entered escalation code survives into the next order.
    dispatch(clearWmsZeroPending());
    dispatch(resetBoxChampState());
    resetBoxChampCatalogRequest();
    resetBoxChampPlanRequest();
  };
}

export function redirectToProductDetail(productId) {
  return (dispatch, getState) => {
    if (!productId) return;
    const {currentOrder} = getState().scanPackScanning;
    const userInfo = getState().user?.userInfo;
    dispatch(ClearSearchProduct());
    navigate('ProductDetail', {
      productInfo: productId,
      orderID: currentOrder?.id,
      increment_id: currentOrder?.increment_id,
      userData: userInfo
    });
  };
}

const FLUSH_WAIT_MS = 3000;

export function flushQueuedScans() {
  return async dispatch => {
    resetSubmitLogThrottle();
    let timer;
    const gaveUp = new Promise(resolve => {
      timer = setTimeout(resolve, FLUSH_WAIT_MS);
    });
    try {
      await Promise.race([
        dispatch(SubmitLog('submitLog')).then(waitForSubmitIdle),
        gaveUp
      ]);
    } finally {
      clearTimeout(timer);
    }
  };
}

export function handleReloadOrder() {
  return async (dispatch, getState) => {
    await dispatch(flushQueuedScans());
    const { currentOrder } = getState().scanPackScanning;
    if (!currentOrder?.increment_id) return;

    const payload = {
      app: 'app',
      input: currentOrder.increment_id,
      state: 'scanpack.rfo'
    };
    dispatch(SearchScanpackOrder(payload, setScanPackCurrentOrder, true));
  };
}

export function refreshOrderNotes() {
  return async (dispatch, getState) => {
    const { currentOrder } = getState().scanPackScanning;
    if (!currentOrder?.id) return;

    const order = await dispatch(GetOrderDetail({ id: currentOrder.id }));
    const basicInfo = order?.basicinfo;
    const latestOrder = getState().scanPackScanning.currentOrder;
    if (!basicInfo || latestOrder?.id !== currentOrder.id) return;

    dispatch(setScanPackCurrentOrder({
      ...latestOrder,
      notes_internal: basicInfo.notes_internal,
      notes_toPacker: basicInfo.notes_toPacker,
      customer_comments: basicInfo.customer_comments
    }));
  };
}

export function handleRemoveItem(scannedBarcode) {
  return async (dispatch, getState) => {
    let { currentOrder, unScannedItems, userInfo, generalSettings, activeBoxIndex } = getStateValues(getState);

    unScannedItems = [...(unScannedItems)];

    if (unScannedItems.length === 0) return;

    const itemToRemove = unScannedItems[0];

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);

    const logData = getRemoveItemLog(currentOrder, itemToRemove, scannedBarcode, userInfo?.name || '', Box);
    attachBoxIdToLog(logData, orderForScan, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    unScannedItems = removeItem(unScannedItems);

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: unScannedItems
    };

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setCurrentItem());

    if (unScannedItems.length === 0) {
      await saveLogToStorage(logData);
      addLocalLog(dispatch, logData);
      dispatch(handleOrderComplete());
    } else {
      saveAndSubmitLog(dispatch, logData);
      await handleScanSuccessFeedback(dispatch, getState);
    }
  };
}

const clearAllUnscannedItems = async (dispatch, getState, barcodeValue) => {
  const { currentOrder, userInfo } = getStateValues(getState);

  const updatedOrder = {
    ...currentOrder,
    unscanned_items: []
  };

  const logData = getPartialCompleteLog(currentOrder, barcodeValue, userInfo?.name || '');
  stampGuidedLog(logData, getState());

  dispatch(setScanPackCurrentOrder(updatedOrder));
  dispatch(setCurrentItem());
  await saveLogToStorage(logData);
  addLocalLog(dispatch, logData);
  dispatch(handleOrderComplete());
};

export function handlePartialComplete(barcodeValue) {
  return (dispatch, getState) => {
    if (dispatch(holdGuidedCompletion())) {
      dispatch(setScanPackBarcodeInput(''));
      return;
    }
    clearAllUnscannedItems(dispatch, getState, barcodeValue);
  };
}

export function handleScannedComplete(barcodeValue) {
  return async (dispatch, getState) => {
    if (dispatch(guidedRefusesScanAll())) return;

    const { currentOrder, userInfo } = getStateValues(getState);

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: []
    };

    const logData = getScannedCompleteLog(currentOrder, barcodeValue, userInfo?.name || '');
    stampGuidedLog(logData, getState());

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setCurrentItem());
    await saveLogToStorage(logData);
    addLocalLog(dispatch, logData);
    dispatch(handleOrderComplete());
  };
}

export function handleSkipItem() {
  return async (dispatch, getState) => {
    let { currentOrder, currentItem, unScannedItems, userInfo, scanPackSettings, generalSettings, activeBoxIndex } = getStateValues(getState);

    unScannedItems = [...unScannedItems];
    if (unScannedItems.length === 0) return;

    if (!currentItem?.skippable) {
      const barcodeValue = scanPackSettings?.skip_code || '';
      const logData = getWrongScanLog(barcodeValue, currentItem, currentOrder, userInfo?.name || '');
      attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
      stampGuidedLog(logData, getState());
      saveAndSubmitLog(dispatch, logData);
      await handleScanErrorFeedback(dispatch, getState);
      return;
    }

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);

    const logData = getSkipLog(currentOrder, currentItem, scanPackSettings, userInfo?.name || '', Box);
    attachBoxIdToLog(logData, orderForScan, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    dispatch(recordGuidedNotFulfilled(unScannedItems[0]));
    unScannedItems = removeItem(unScannedItems);

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: unScannedItems
    };

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setCurrentItem());

    if (unScannedItems.length === 0) {
      await saveLogToStorage(logData);
      addLocalLog(dispatch, logData);
      dispatch(handleOrderComplete());
    } else {
      saveAndSubmitLog(dispatch, logData);
      await handleScanSuccessFeedback(dispatch, getState);
    }
  };
}

export function handleNotFulfilled() {
  return async (dispatch, getState) => {
    let { currentOrder, unScannedItems } = getStateValues(getState);

    unScannedItems = [...(unScannedItems)];
    if (unScannedItems.length === 0) return;

    const notFulfilledItem = getFirstItem(unScannedItems);

    const guidedNotFulfilledBefore = boxChampOf(getState()).notFulfilledItems;
    dispatch(recordGuidedNotFulfilled(unScannedItems[0]));
    unScannedItems = removeItem(unScannedItems);

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: unScannedItems,
      held_items: [
        ...(currentOrder?.held_items || []),
        {...notFulfilledItem, skipped_qty: notFulfilledItem.qty_remaining, qty_remaining: 0}
      ]
    };

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setCurrentItem());
    const listAfterHold = getState().scanPackScanning.currentOrder?.unscanned_items;

    const held = holdOrderItemNotFulfilled(notFulfilledItem.order_item_id, notFulfilledItem.product_id)
      .then(() => ({ok: true}), error => ({ok: false, error}));

    if (unScannedItems.length === 0) {
      setScanPackLoadingState(dispatch, true);
      const holdResult = await held;
      setScanPackLoadingState(dispatch, false);
      const latest = getState().scanPackScanning.currentOrder;
      if (latest?.id !== currentOrder?.id || latest?.unscanned_items !== listAfterHold) return;
      if (!holdResult.ok) {
        dispatch(setBoxChampState({notFulfilledItems: guidedNotFulfilledBefore}));
        dispatch(setScanPackCurrentOrder(currentOrder));
        dispatch(setCurrentItem());
        dispatch(setScanPackPrompt(true, i18n.t('scanpackItem.not_fulfilled_failed'), 'alert', '', false));
        audioService.playErrorSound();
        return;
      }
      dispatch(handleOrderComplete());
    } else {
      playSuccessFeedback(getState);
    }
  };
}

export function handleBarcodeSubmit() {
  return async (dispatch, getState) => {
    const { barcodeValue, currentOrder, currentItem, scanPackSettings, generalSettings, userInfo, activeBoxIndex, unScannedItems } = getStateValues(getState);
    const { loading } = getState().scanPackScanning;

    if (loading) {
      dispatch(setScanPackBarcodeInput(''));
      return;
    }

    if (!barcodeValue) {
      handleNotReady(dispatch, scanPackSettings);
      return;
    }

    const noteFromPacker = currentOrder?.notes_fromPacker || '';
    const scanningSequence = scanPackSettings?.scanning_sequence || 'items_sequence';
    const isKitPackingMode = scanningSequence === 'kit_packing_mode';
    const isAnySequence = scanningSequence === 'any_sequence' || isKitPackingMode;

    let processedBarcode = processBarcodeInput(barcodeValue, scanPackSettings, false);

    const actionType = getActionBarcodeType(processedBarcode, scanPackSettings, generalSettings);

    const caseInsensitiveScan = !actionType && (isAnySequence && !isKitPackingMode || (isKitPackingMode && !generalSettings?.master_switch));
    if (caseInsensitiveScan) {
      processedBarcode = processedBarcode.toLowerCase();
    }

    if (dispatch(runGuidedScanPrelude({ rawValue: barcodeValue, processedValue: processedBarcode, caseInsensitive: caseInsensitiveScan }))) {
      return;
    }

    const promptActionMap = {
      RESTART: () => dispatch(setScanPackPrompt(true, '', 'restart', '', false)),
      NOTE_FROM_PACKER: () => dispatch(setScanPackPrompt(true, '', 'note_from_packer', noteFromPacker, false)),
      SERVICE_ISSUE: () => dispatch(setScanPackPrompt(true, '', 'service_issue_note', noteFromPacker, false)),
      ADD_NEXT: () => {
        const msg = userInfo?.role?.add_edit_order_items
          ? i18n.t('AddNextBarcode.search_item_msg')
          : i18n.t('AddNextBarcode.confirmation_code_msg');
        dispatch(setScanPackPrompt(true, msg, 'add_item', '', false));
      },
      CLICK_SCAN: () => dispatch(handlePassButton()),
      PASS_SCAN: () => dispatch(handlePassButton()),
      REMOVE: () => dispatch(handleRemoveItem(processedBarcode)),
      PARTIAL: () => dispatch(handlePartialComplete(processedBarcode)),
      SCANNED: () => dispatch(handleScannedComplete(processedBarcode)),
      SKIP: () => dispatch(handleSkipItem()),
      NOT_FULFILLED: () => dispatch(handleNotFulfilled()),
      BOXPREV: () => dispatch(handleBoxNavigation('prev')),
      BOXNEXT: () => dispatch(handleBoxNavigation('next'))
    };

    if (actionType) {
      dispatch(setScanPackBarcodeInput(''));
      if (actionType === 'RESTART' && dispatch(refuseRestartAwaitingLastSeal())) return;
      if (promptActionMap[actionType]) {
         const actions = ['RESTART', 'NOTE_FROM_PACKER', 'SERVICE_ISSUE', 'ADD_NEXT'];
        if (actions.includes(actionType)) {
          dispatch(setScanPackMainInputFocus(false));
        }
        promptActionMap[actionType]();
      }
      return;
    }

    if (currentItem?.skippable && checkIsDisabledSkipBarcode(processedBarcode, scanPackSettings, usesLowercaseMatching(scanPackSettings, generalSettings))) {
      dispatch(setScanPackPrompt(true, i18n.t('scanpackItem.Disable_skip_msg'), 'alert', '', false));
      dispatch(setScanPackBarcodeInput(''));
      await playNotReadyFeedback(getState);
      return;
    }

    const typeScanResult = handleTypeScan(getState(), processedBarcode);
    if (typeScanResult) {
      dispatch(setScanPackPrompt(true, typeScanResult.message, typeScanResult.promptType, '', false));
      if (typeScanResult.playError) {
        await playErrorFeedback(getState);
      }
      dispatch(setScanPackBarcodeInput(''));
      return;
    }

    const itemToScan = resolveItemToScan(dispatch, processedBarcode, isAnySequence, currentItem, currentOrder, unScannedItems);

    if (!itemToScan) {
      const wrongScanLog = getWrongScanLog(barcodeValue, currentItem, currentOrder, userInfo?.name || '');
      attachBoxIdToLog(wrongScanLog, currentOrder, activeBoxIndex, generalSettings);
      stampGuidedLog(wrongScanLog, getState());
      await saveAndSubmitLog(dispatch, wrongScanLog, false);
      await handleScanErrorFeedback(dispatch, getState);
      return;
    }

    const productInstructionsResult = checkProductInstructions(itemToScan, generalSettings);
    if (productInstructionsResult.showPrompt) {
      dispatch(setScanPackPrompt(true, '', 'product_instructions_confirmation', '', false));
      return;
    }

    const serialScanResult = checkSerialRecordingEnabled(itemToScan);
    if (serialScanResult.showPrompt) {
      dispatch(setScanPackPrompt(true, serialScanResult.message, 'serial_scan', '', false));
      return;
    }

    const wmsLotResult = checkWmsLotVerification(itemToScan);
    if (wmsLotResult.showPrompt) {
      dispatch(setScanPackPrompt(true, wmsLotResult.message, 'wms_lot_verification', '', false));
      return;
    }

    if (shouldGateForZeroInventory(itemToScan)) {
      dispatch(submitZeroInventoryGate(processedBarcode, barcodeValue));
      return;
    }

    dispatch(processItemScan(processedBarcode, false, null, false, barcodeValue));
  };
}

// `skipServerSubmit` is set only by the WMS L2/L3 round trip (submitWmsLotVerification): that
// caller already sent this exact scan to the server synchronously via `submitGatedScan` and got a
// definitive "committed" answer back, so queuing this SAME scan into the normal async/batched log
// submission here would double-submit it server-side. Local state (order/UI/activity log) still
// updates normally either way — only the server round trip is skipped.
//
// `rawBarcodeValue` defaults to `barcodeValue` so the other callers, which never see GS1 input,
// are unaffected.
export function processItemScan(barcodeValue, skipLocalLog = false, bulkType = null, skipServerSubmit = false, rawBarcodeValue = barcodeValue) {
  return async (dispatch, getState) => {
    const { currentItem, currentOrder, unScannedItems, scannedItems, userInfo, scanPackSettings, generalSettings, activeBoxIndex } = getStateValues(getState);

    if (!currentItem || !currentOrder) {
      return;
    }

    if (!skipServerSubmit && dispatch(guidedRefusesItemScan(currentItem))) {
      return;
    }

    let updatedItem;
    const qtyToScan = currentItem.qty_remaining || 0;
    const packingCount = bulkType ? 1 : getPackingCount(currentItem, barcodeValue);

    if (!bulkType && barcodeValue && qtyToScan < packingCount) {
      dispatch(setScanPackPrompt(true, i18n.t('scanpackItem.Scanpack_multipack_msg'), 'alert', '', false));
      dispatch(setScanPackBarcodeInput(''));
      return;
    }

    if (bulkType) {
      updatedItem = bulkScanItem(currentItem);
    } else {
      updatedItem = updateItemQty(currentItem, false);
      updatedItem = adjustForPackingCount(updatedItem, packingCount);
    }

    const newScannedItems = updateScannedItemsList([...scannedItems], updatedItem);
    const newUnScannedItems = updateUnScannedItemsList([...unScannedItems], updatedItem);

    const { multiBox, orderForScan, localBoxId, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);

    let updatedOrder;
    if (bulkType && multiBox && localBoxId) {
      updatedOrder = updateOrderAfterScan(orderForScan, updatedItem, newScannedItems, newUnScannedItems);
      updatedOrder = {
        ...updatedOrder,
        order_item_boxes: addBoxItemToOrder(updatedOrder, localBoxId, currentItem, qtyToScan)
      };
    } else {
      updatedOrder = updateOrderAfterScan(orderForScan, updatedItem, newScannedItems, newUnScannedItems, localBoxId, packingCount);
    }

    const kitRoundResult = checkKitRoundComplete(newUnScannedItems, newScannedItems, unScannedItems);
    let finalUnScannedItems = newUnScannedItems;
    let finalScannedItems = newScannedItems;
    if (kitRoundResult) {
      const kitUpdate = applyKitParentQtyUpdate(newUnScannedItems, newScannedItems, kitRoundResult);
      finalUnScannedItems = kitUpdate.unScannedItems;
      finalScannedItems = kitUpdate.scannedItems;
      updatedOrder = {
        ...updatedOrder,
        unscanned_items: finalUnScannedItems,
        scanned_items: finalScannedItems
      };
      if ((kitRoundResult.type === 'depends_round' || kitRoundResult.type === 'depends_complete') && multiBox && localBoxId) {
        updatedOrder = {
          ...updatedOrder,
          order_item_boxes: addBoxItemToOrder(updatedOrder, localBoxId, kitRoundResult.parentItem, 1)
        };
      }
    }

    const kitChild = isKitChildItem(currentItem, unScannedItems);
    const logData = bulkType
      ? buildBulkScanLog(currentOrder, scanPackSettings, currentItem, unScannedItems, bulkType, userInfo?.name || '')
      : getRegularScanLog(currentOrder, currentItem, rawBarcodeValue, userInfo?.name || '', Box, kitChild, {}, barcodeValue);

    attachBoxIdToLog(logData, orderForScan, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    dispatch(setScanPackCurrentOrder(updatedOrder));
    if (bulkType) {
      dispatch(setTypeScanAdjacentScans(0));
    } else {
      const { typeScanState, typeScanAdjacentScans } = getState().scanPackScanning;
      dispatch(setTypeScanAdjacentScans(nextAdjacentScanCount(typeScanState, typeScanAdjacentScans, currentItem.sku)));
      dispatch(setTypeScanState(currentItem.sku));
    }
    dispatch(setCurrentItem());

    if (finalUnScannedItems.length === 0) {
      if (!skipServerSubmit) {
        await saveLogToStorage(logData);
      }
      if (!skipLocalLog) addLocalLog(dispatch, logData);
      dispatch(handleOrderComplete());
    } else {
      if (skipServerSubmit) {
        if (!skipLocalLog) addLocalLog(dispatch, logData);
      } else {
        saveAndSubmitLog(dispatch, logData, skipLocalLog);
      }
      await handleScanSuccessFeedback(dispatch, getState);
      if (kitRoundResult) {
        const kitUpdate = applyKitParentQtyUpdate(newUnScannedItems, newScannedItems, kitRoundResult);
        if (kitUpdate.showKitPopup) {
          dispatch(setScanPackPrompt(true, kitUpdate.kitInstructions, 'kit_confirmation', '', false));
        }
      }
    }
  };
}

export function handlePassButton(item, isShiftKey = false) {
  return (dispatch, getState) => {
    const { currentItem, currentOrder, barcodeValue, userInfo, scanPackSettings, generalSettings } = getStateValues(getState);
    const overridePassButton = userInfo?.override_pass_scanning;


    if (barcodeValue && barcodeValue.trim() !== '') {
      dispatch(handleBarcodeSubmit());
      return;
    }

    const itemToPass = item || currentItem;

    const clickScanResult = checkClickScanEnabled(itemToPass, scanPackSettings, overridePassButton, isShiftKey);
    if (clickScanResult.type !== 'ClickScanDisabled' && dispatch(guidedRefusesItemScan(itemToPass))) {
      return;
    }
    if (clickScanResult.showPrompt) {
      const promptType = clickScanResult.type === 'ClickScanConfirmation' ? 'click_scan_confirmation' : 'alert';
      dispatch(setScanPackPrompt(true, clickScanResult.message, promptType, '', false));
      if (clickScanResult.type === 'ClickScanDisabled') {
        playNotReadyFeedback(getState);
      }
      return;
    }

    const productInstructionsResult = checkProductInstructions(itemToPass, generalSettings);
    if (productInstructionsResult.showPrompt) {
      dispatch(setScanPackPrompt(true, '', 'product_instructions_confirmation', '', false));
      return;
    }

    const serialScanResult = checkSerialRecordingEnabled(itemToPass);
    if (serialScanResult.showPrompt) {
      dispatch(setScanPackPrompt(true, serialScanResult.message, 'serial_scan', '', false));
      return;
    }

    const wmsLotResult = checkWmsLotVerification(itemToPass);
    if (wmsLotResult.showPrompt) {
      dispatch(setScanPackPrompt(true, wmsLotResult.message, 'wms_lot_verification', '', false));
      return;
    }

    if (shouldGateForZeroInventory(itemToPass)) {
      dispatch(submitZeroInventoryGate(''));
      return;
    }

    dispatch(processItemScan(''));
  };
}

export function submitTypeScan() {
  return async (dispatch, getState) => {
    let { prompt, currentOrder, unScannedItems, scannedItems, generalSettings, typeScanAdjacentScans, userInfo, activeBoxIndex } = getStateValues(getState);
    const typeScanCount = quantityAfterScanDeduction(parseInt(prompt.input) || 1, typeScanAdjacentScans);

    unScannedItems = [...(unScannedItems)];
    scannedItems = [...(scannedItems)];

    if (unScannedItems.length === 0) return;

    const firstItem = unScannedItems[0];
    const itemToProcess = getItemToProcess(firstItem);

    if (dispatch(guidedRefusesItemScan(itemToProcess))) {
      dispatch(closePrompt());
      return;
    }

    if (typeScanCount === 0) {
      dispatch(setTypeScanState(itemToProcess.sku));
      dispatch(setTypeScanAdjacentScans(0));
      dispatch(closePrompt());
      return;
    }

    const {remaining: remainingForItem} = getItemCounts(itemToProcess);

    if (remainingForItem < typeScanCount) {
      dispatch(setScanPackPrompt(true, i18n.t('scanpackItem.Scanpack_Item_Typecount_exceed_error'), 'alert', '', false));
      playErrorFeedback(getState);
      return;
    }

    let currentItemToUpdate = {...itemToProcess};
    const originalUnScannedItems = [...unScannedItems];

    for (let i = 0; i < typeScanCount; i++) {
      currentItemToUpdate = updateItemQty(currentItemToUpdate, false);
      scannedItems = updateScannedItemsList(scannedItems, currentItemToUpdate);
      unScannedItems = updateUnScannedItemsList(unScannedItems, currentItemToUpdate);
    }

    const { multiBox, orderForScan, localBoxId, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const orderInputType = getFirstBarcode(itemToProcess, '');

    let updatedOrder = updateOrderAfterScan(orderForScan, currentItemToUpdate, scannedItems, unScannedItems);

    if (multiBox && localBoxId) {
      updatedOrder = {
        ...updatedOrder,
        order_item_boxes: addBoxItemToOrder(updatedOrder, localBoxId, itemToProcess, typeScanCount)
      };
    }

    const logData = getTypeScanLog(
      currentOrder,
      orderInputType,
      typeScanCount,
      'type_scan',
      firstItem,
      itemToProcess.sku,
      Box,
      userInfo?.name || ''
    );

    attachBoxIdToLog(logData, orderForScan, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    const kitRoundResult = checkKitRoundComplete(unScannedItems, scannedItems, originalUnScannedItems);
    let finalUnScannedItems = unScannedItems;
    let finalScannedItems = scannedItems;
    let kitPopup = null;
    if (kitRoundResult) {
      const kitUpdate = applyKitParentQtyUpdate(unScannedItems, scannedItems, kitRoundResult);
      kitPopup = kitUpdate;
      finalUnScannedItems = kitUpdate.unScannedItems;
      finalScannedItems = kitUpdate.scannedItems;
      updatedOrder = {
        ...updatedOrder,
        unscanned_items: finalUnScannedItems,
        scanned_items: finalScannedItems
      };
      if ((kitRoundResult.type === 'depends_round' || kitRoundResult.type === 'depends_complete') && multiBox && localBoxId) {
        updatedOrder = {
          ...updatedOrder,
          order_item_boxes: addBoxItemToOrder(updatedOrder, localBoxId, kitRoundResult.parentItem, 1)
        };
      }
    }

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setTypeScanState(itemToProcess.sku));
    dispatch(setTypeScanAdjacentScans(0));
    dispatch(setCurrentItem());
    dispatch(closePrompt());

    if (finalUnScannedItems.length === 0) {
      await saveLogToStorage(logData);
      addLocalLog(dispatch, logData);
      dispatch(handleOrderComplete());
    } else {
      saveAndSubmitLog(dispatch, logData, false);
      await handleScanSuccessFeedback(dispatch, getState);
      if (kitPopup?.showKitPopup) {
        dispatch(setScanPackPrompt(true, kitPopup.kitInstructions, 'kit_confirmation', '', false));
      }
    }
  };
}

export function handleScanAll(bulkType = 'bulk_scan') {
  return (dispatch, getState) => {
    const { currentItem, unScannedItems } = getStateValues(getState);

    if (unScannedItems.length === 0 || !currentItem) return;

    if (currentItem.click_scan_enabled === 'off' && bulkType === 'scan_all_items') {
      dispatch(setScanPackPrompt(true, i18n.t('scanpackItem.Scanpack_pass_fun_msg'), 'alert', '', false));
      playErrorFeedback(getState);
      return;
    }

    if (dispatch(guidedRefusesItemScan(currentItem))) return;

    const serialResult = checkSerialRecordingEnabled(currentItem);
    if (serialResult.showPrompt) {
      dispatch(setScanPackPrompt(true, serialResult.message, 'serial_scan', '', false));
      return;
    }

    dispatch(processItemScan('', false, bulkType));
  };
}

export function submitSerialScan() {
  return async (dispatch, getState) => {
    const { prompt, currentItem, currentOrder, userInfo, scanPackSettings, generalSettings, activeBoxIndex } = getStateValues(getState);
    const serialInput = prompt.input;

    if (!currentItem || !serialInput) return;

    const serialValidation = validateSerialRecord(serialInput, scanPackSettings, userInfo);
    if (!serialValidation.isValid) {
      dispatch(setScanPackPrompt(true, prompt.message, 'serial_scan', '', serialValidation.errorMessage));
      await playErrorFeedback(getState);
      return;
    }

    const both = currentItem.record_serial && currentItem.second_record_serial;
    const { temp, localLog } = getSerialRecordLog(
      serialInput,
      userInfo?.name || '',
      'scan',
      currentItem,
      'recordOne',
      currentOrder?.id,
      both
    );

    attachBoxIdToLog(temp, currentOrder, activeBoxIndex, generalSettings);
    stampGuidedLog(temp, getState());

    if (both) {
      dispatch(setScanPackPrompt(true, i18n.t('serialRecord.serial_number_two'), 'serial_scan_second', serialInput, false));
      return;
    }

    await completeSerialScan(dispatch, getState, temp, localLog);
  };
}

export function submitSerialScanSecond() {
  return async (dispatch, getState) => {
    const { prompt, currentItem, currentOrder, userInfo, scanPackSettings, generalSettings, activeBoxIndex } = getStateValues(getState);
    const secondSerialInput = prompt.input;
    const firstSerialInput = prompt.message;

    if (!secondSerialInput || !currentItem) {
      return;
    }

    const serialValidation = validateSerialRecord(secondSerialInput, scanPackSettings, userInfo);
    if (!serialValidation.isValid) {
      dispatch(setScanPackPrompt(true, firstSerialInput, 'serial_scan_second', '', serialValidation.errorMessage));
      playNotReadyFeedback(getState);
      return;
    }

    const { temp, localLog } = getSerialRecordLog(
      secondSerialInput,
      userInfo?.name || '',
      'scan',
      currentItem,
      'recordTwo',
      currentOrder?.id,
      true
    );

    attachBoxIdToLog(temp, currentOrder, activeBoxIndex, generalSettings);
    stampGuidedLog(temp, getState());

    await completeSerialScan(dispatch, getState, temp, localLog);
  };
}

export function submitNoteFromPacker() {
  return async (dispatch, getState) => {
    const { prompt, currentOrder, generalSettings, activeBoxIndex, userInfo } = getStateValues(getState);
    const noteFromPacker = prompt.input;

    const updatedOrder = {
      ...currentOrder,
      notes_fromPacker: noteFromPacker
    }

    dispatch(setScanPackCurrentOrder(updatedOrder));

    const logData = getNoteLog(
      currentOrder,
      noteFromPacker,
      userInfo?.name || ''
    );

    attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    await saveAndSubmitLog(dispatch, logData);
    dispatch(closePrompt());
  };
}

export function submitServiceIssueNote() {
  return async (dispatch, getState) => {
    const { prompt, currentOrder, scanPackSettings, generalSettings, activeBoxIndex, userInfo } = getStateValues(getState);
    const noteFromPacker = prompt.input;

    if (!currentOrder?.id || !scanPackSettings?.service_issue_code || !noteFromPacker) return;

    const userName = userInfo?.name || '';
    const persistLog = async (logData) => {
      attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
      stampGuidedLog(logData, getState());
      await saveLogToStorage(logData);
      addLocalLog(dispatch, logData);
    };

    await persistLog(getServiceIssueLog(currentOrder, scanPackSettings, userName));
    await persistLog(getNoteLog(currentOrder, noteFromPacker, userName));

    resetSubmitLogThrottle();
    await dispatch(SubmitLog('submitLog'));

    const navSource = getState().scanPackScanning.navigationSource;
    dispatch(reset());
    dispatch(closePrompt());
    navigateBack(getState, navSource);
  };
}

export function submitClickScanConfirmation() {
  return async (dispatch, getState) => {
    const { prompt, currentItem, currentOrder, userInfo, generalSettings, activeBoxIndex } = getStateValues(getState);
    const userInput = prompt.input;

    if (!currentItem || !currentOrder) return;

    const { isMatch, allowBypass } = validateConfirmationCode(userInput, userInfo.confirmation_code, generalSettings?.strict_cc);

    if (isMatch || allowBypass) {
      const logData = getByPassLog(userInfo?.name || '', currentOrder);
      attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
      stampGuidedLog(logData, getState());

      await saveLogToStorage(logData);
      addLocalLog(dispatch, logData);

      dispatch(closePrompt());

      dispatch(processItemScan(''));
    } else {
      dispatch(setScanPackPrompt(
        true,
        '',
        'click_scan_confirmation',
        '',
        true
      ));
      playNotReadyFeedback(getState);
    }
  };
}

export function submitTypeScanConfirmation() {
  return (dispatch, getState) => {
    const { prompt, userInfo, generalSettings } = getStateValues(getState);

    const { isMatch, isEmpty, allowBypass } = validateConfirmationCode(
      prompt.input,
      userInfo?.confirmation_code,
      generalSettings?.strict_cc
    );

    if (isMatch || (isEmpty && allowBypass)) {
      dispatch(setScanPackPrompt(true, '', 'type_scan', '', false));
    } else {
      dispatch(setScanPackPrompt(true, '', 'type_scan_confirmation', '', true));
      playNotReadyFeedback(getState);
    }
  };
}

export function submitProductInstructionsConfirmation() {
  return async (dispatch, getState) => {
    const { prompt, barcodeValue, currentItem, userInfo, generalSettings } = getStateValues(getState);
    const userInput = prompt.input;

    const { isMatch, isEmpty, allowBypass } = validateConfirmationCode(
      userInput,
      userInfo?.confirmation_code,
      generalSettings?.strict_cc
    );

    if (isMatch || (isEmpty && allowBypass)) {
      dispatch(closePrompt());

      const serialScanResult = checkSerialRecordingEnabled(currentItem);
      if (serialScanResult.showPrompt) {
        dispatch(setScanPackPrompt(true, serialScanResult.message, 'serial_scan', '', false));
        return;
      }

      dispatch(processItemScan(barcodeValue || ''));
    } else {
      dispatch(setScanPackPrompt(true, '', 'product_instructions_confirmation', '', true));
      playNotReadyFeedback(getState);
    }
  };
}

// The SERVER decides whether an L2/L3-gated scan commits (Groovepacker::Inventory::LotScanGate) —
// it is the only thing holding the ledger, so this thunk never marks the item accepted on its own
// say-so. Client-side validation (`validateWmsLotAnswer`) is used ONLY as an advisory fast-fail:
// it saves a doomed round trip when the answer is already, obviously wrong, but a match there is
// NOT treated as authorization to commit — only the server's response (no `ask` back) is.
export function submitWmsLotVerification() {
  return async (dispatch, getState) => {
    const { prompt, barcodeValue, currentItem, currentOrder, userInfo, activeBoxIndex, generalSettings, scanPackSettings } = getStateValues(getState);
    const userInput = prompt.input;

    const wmsLotResult = checkWmsLotVerification(currentItem);
    if (!wmsLotResult.showPrompt) {
      // The ladder no longer applies (item changed underneath the prompt) — let the scan through
      // rather than stranding the packer on a stale prompt.
      dispatch(closePrompt());
      dispatch(processItemScan(barcodeValue || ''));
      return;
    }

    // Advisory pre-check only — see function comment. A local mismatch re-prompts immediately
    // without ever contacting the server, since the server would reject it too.
    const { isMatch } = validateWmsLotAnswer(userInput, wmsLotResult.level, currentItem, userInfo);
    if (!isMatch) {
      const errorMessage = wmsLotResult.level === 'L2'
        ? i18n.t('wmsLotVerification.confirmationCodeError')
        : i18n.t('wmsLotVerification.lotNumberError');
      dispatch(setScanPackPrompt(true, wmsLotResult.message, 'wms_lot_verification', '', errorMessage));
      playNotReadyFeedback(getState);
      return;
    }

    // Locally-plausible answer — now ask the server, which is authoritative. Nothing local or
    // committed changes until this resolves.
    setScanPackLoadingState(dispatch, true);

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const logEntry = getRegularScanLog(orderForScan, currentItem, barcodeValue, userInfo?.name || '', Box, false, { wmsLotAnswer: userInput }, processBarcodeInput(barcodeValue, scanPackSettings, false));

    stampGuidedLog(logEntry, getState());
    const ask = await submitGatedScan(logEntry);

    setScanPackLoadingState(dispatch, false);

    if (ask) {
      // The server intercepted it — `error` is present once the packer has already answered
      // wrong (absent on a first ask), exactly mirroring LotScanGate#ask_payload.
      const errorMessage = ask.error || (
        wmsLotResult.level === 'L2'
          ? i18n.t('wmsLotVerification.confirmationCodeError')
          : i18n.t('wmsLotVerification.lotNumberError')
      );
      dispatch(setScanPackPrompt(true, wmsLotResult.message, 'wms_lot_verification', '', errorMessage));
      playNotReadyFeedback(getState);
      return;
    }

    // The server committed the scan — now, and only now, reflect it locally. `skipServerSubmit`
    // stops this same scan from also going out through the normal async/batched log queue, which
    // would double-submit it.
    dispatch(closePrompt());
    dispatch(processItemScan(barcodeValue || '', false, null, true));
  };
}

// =============================================================
// WMS Z1-Z3 zero-inventory ladder — stop-and-receive (Z3)
//
// Mirrors submitWmsLotVerification's posture: the SERVER decides everything (which Z rung is
// configured, whether it stops the packer, whether an escalation code or a bypass is accepted) —
// this code only surfaces the server's ask, collects the packer's answer, and commits nothing on
// its own say-so. See groovepacker-wms-integration's wms_zero_inventory ask payload for the full
// contract this block builds against.
// =============================================================

// Renders whichever step of the ask the server is currently on: escalation (packer lacks
// product-edit permission) or receive (lot then quantity, chained like serial_scan/
// serial_scan_second — see ScanPackPrompts.js). Do NOT branch on `stop` here — the only reliable
// signal that the packer is actually held is the presence of `receiving` itself, which is why
// this function is only ever called with a non-null `receiving`.
const openWmsZeroReceivingPrompt = (dispatch, receiving, pending) => {
  dispatch(setWmsZeroPending({
    ...pending,
    canBypass: !!receiving.can_bypass
  }));

  if (receiving.needs_escalation) {
    dispatch(setScanPackPrompt(true, receiving.message, 'wms_zero_escalation', '', receiving.error || false));
    return;
  }

  const message = receiving.authorized_by
    ? i18n.t('wmsZeroInventory.authorizedByMessage', { message: receiving.message, authorizedBy: receiving.authorized_by })
    : receiving.message;

  // WHICH STEP TO RE-RENDER. The backend collapses lot + quantity into ONE combined check
  // (ZeroInventoryReceivingGate#resolve_and_receive) and returns a single generic error with no
  // per-field signal, so the response itself cannot tell us which half the packer got wrong
  // (confirmed with Kapil, 2026-08-20). `pending.lot` is the only reliable discriminator of how
  // far through the ladder they are: EMPTY means they have not supplied a lot yet, so this is
  // the first receive ask and the lot step is correct; non-empty means they are past the lot step
  // and a re-ask belongs on the quantity step. Note the check must be on truthiness, not key
  // presence — submitZeroInventoryGate seeds pending as `{escalationCode: '', lot: '', ...}`, so
  // `'lot' in pending` is always true and would route every first ask to the wrong step.
  // Previously this branch always rendered
  // `wms_zero_receive_lot`, so a rejected lot/qty pair bounced the packer back to re-type a lot
  // that was probably fine, and any qty-specific error text rendered under the lot step's testID.
  //
  // Residual, and deliberate: because the error is generic, a genuinely WRONG lot re-asks on the
  // quantity step. The packer's way out is Cancel, which clears wmsZeroPending and restarts the
  // ladder on the next scan. Distinguishing the two needs a per-field signal from the backend —
  // out of scope here, and not something to fake client-side.
  const step = pending?.lot ? 'wms_zero_receive_qty' : 'wms_zero_receive_lot';
  dispatch(setScanPackPrompt(true, message, step, '', receiving.error || false));
};

// Common tail for every Z3 round trip: `receiving` present means the server is still holding the
// packer (escalation rejected, receive rejected, or bypass rejected) — re-render whichever step
// it asks for next. `receiving` absent means the server committed the scan (accepted receive,
// accepted bypass, OR a network/client failure degrading to fail-soft "let the scan through" —
// submitGatedZeroScan makes these three indistinguishable on purpose, matching WmsLotScanGate's
// own `rescue StandardError` -> allow posture). Either way, `wmsZeroPending` is cleared before the
// scan commits — a stale escalation code must never leak into a later, unrelated scan.
const handleWmsZeroAskResult = (dispatch, receiving, pending, barcodeValue) => {
  if (receiving) {
    openWmsZeroReceivingPrompt(dispatch, receiving, pending);
    return;
  }

  dispatch(clearWmsZeroPending());
  dispatch(closePrompt());
  dispatch(processItemScan(barcodeValue || '', false, null, true));
};

// Entry point: a shortage is SUSPECTED (product-level on-hand <= 0 per shouldGateForZeroInventory)
// but whether it actually stops the packer is unknowable client-side — only the server knows the
// configured Z rung. So this submits the scan itself through the synchronous single-entry round
// trip instead of the normal optimistic/batched queue, and lets the server's response decide.
const wmsZeroRawBarcode = (pending) => pending?.rawBarcodeValue ?? pending?.barcodeValue;

export function submitZeroInventoryGate(barcodeValue, rawBarcodeValue = barcodeValue) {
  return async (dispatch, getState) => {
    const { currentItem, currentOrder, userInfo, activeBoxIndex, generalSettings } = getStateValues(getState);
    if (!currentItem || !currentOrder) return;

    setScanPackLoadingState(dispatch, true);

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const logEntry = getRegularScanLog(orderForScan, currentItem, rawBarcodeValue, userInfo?.name || '', Box, false, {}, barcodeValue);

    stampGuidedLog(logEntry, getState());
    const receiving = await submitGatedZeroScan(logEntry);

    setScanPackLoadingState(dispatch, false);

    handleWmsZeroAskResult(dispatch, receiving, { escalationCode: '', lot: '', barcodeValue, rawBarcodeValue }, barcodeValue);
  };
}

// Step 1 (only when `needs_escalation: true`): the confirmation code is submitted ALONE first,
// without lot/qty. The server would accept all three in one request, but validating the code
// first gives the packer a clear rejection and yields `authorized_by` before asking them for
// anything else — a wrong code shouldn't cost the packer a wasted lot/qty entry.
export function submitWmsZeroEscalation() {
  return async (dispatch, getState) => {
    const { prompt, currentItem, currentOrder, userInfo, activeBoxIndex, generalSettings, wmsZeroPending } = getStateValues(getState);
    const code = prompt.input;
    const pending = { ...wmsZeroPending, escalationCode: code };

    setScanPackLoadingState(dispatch, true);

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const logEntry = getRegularScanLog(orderForScan, currentItem, wmsZeroRawBarcode(wmsZeroPending), userInfo?.name || '', Box, false, {
      wmsZeroEscalationCode: code
    }, wmsZeroPending?.barcodeValue);

    stampGuidedLog(logEntry, getState());
    const receiving = await submitGatedZeroScan(logEntry);

    setScanPackLoadingState(dispatch, false);

    handleWmsZeroAskResult(dispatch, receiving, pending, wmsZeroPending?.barcodeValue);
  };
}

// Step 2a: lot number. Required, non-blank. Advances to the quantity step without contacting the
// server — the server only sees the combined lot+qty (+ escalation code, when applicable)
// together once the quantity is also collected, exactly mirroring the serial_scan /
// serial_scan_second chained-prompt pattern.
export function submitWmsZeroReceiveLot() {
  return (dispatch, getState) => {
    const { prompt, wmsZeroPending } = getStateValues(getState);
    const lot = (prompt.input || '').trim();

    if (!lot) {
      dispatch(setScanPackPrompt(true, prompt.message, 'wms_zero_receive_lot', '', i18n.t('wmsZeroInventory.lotRequiredError')));
      playNotReadyFeedback(getState);
      return;
    }

    dispatch(setWmsZeroPending({ ...wmsZeroPending, lot }));
    dispatch(setScanPackPrompt(true, prompt.message, 'wms_zero_receive_qty', '', false));
  };
}

// Step 2b: quantity. `validateWmsZeroReceiveQty` is an ADVISORY fast-fail only (see its doc
// comment) — a locally-plausible quantity is not authorization, only the server's response
// (no further `receiving` ask) commits the scan. The escalation code, when this packer needed
// one, is re-sent here alongside lot + quantity, exactly as the backend contract requires.
export function submitWmsZeroReceiveQty() {
  return async (dispatch, getState) => {
    const { prompt, currentItem, currentOrder, userInfo, activeBoxIndex, generalSettings, wmsZeroPending } = getStateValues(getState);
    const qty = prompt.input;

    if (!validateWmsZeroReceiveQty(qty)) {
      dispatch(setScanPackPrompt(true, prompt.message, 'wms_zero_receive_qty', '', i18n.t('wmsZeroInventory.qtyRequiredError')));
      playNotReadyFeedback(getState);
      return;
    }

    setScanPackLoadingState(dispatch, true);

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const logEntry = getRegularScanLog(orderForScan, currentItem, wmsZeroRawBarcode(wmsZeroPending), userInfo?.name || '', Box, false, {
      wmsZeroReceiveLot: wmsZeroPending?.lot,
      wmsZeroReceiveQty: qty,
      wmsZeroEscalationCode: wmsZeroPending?.escalationCode || undefined
    }, wmsZeroPending?.barcodeValue);

    stampGuidedLog(logEntry, getState());
    const receiving = await submitGatedZeroScan(logEntry);

    setScanPackLoadingState(dispatch, false);

    handleWmsZeroAskResult(dispatch, receiving, wmsZeroPending, wmsZeroPending?.barcodeValue);
  };
}

// Bypass ("Pass") — permissive mode only. `can_bypass` (surfaced to the UI as
// `wmsZeroPending.canBypass`) is the ONLY signal that gates whether this affordance renders; it
// must never be inferred from mode/strict-vs-permissive or anything else client-side (see
// ScanPackPrompts.js's wms_zero_* renderers). A bypass does not write a WmsInventoryInstance row
// server-side — it flags a recount queue item instead — but from this client's point of view it
// resolves identically to a successful receive: the scan commits in the same response.
export function submitWmsZeroBypass() {
  return async (dispatch, getState) => {
    const { currentItem, currentOrder, userInfo, activeBoxIndex, generalSettings, wmsZeroPending } = getStateValues(getState);

    setScanPackLoadingState(dispatch, true);

    const { orderForScan, boxName: Box } = resolveMultiBoxContext(dispatch, getState, currentOrder, generalSettings, activeBoxIndex);
    const logEntry = getRegularScanLog(orderForScan, currentItem, wmsZeroRawBarcode(wmsZeroPending), userInfo?.name || '', Box, false, {
      wmsZeroEscalationCode: wmsZeroPending?.escalationCode || undefined,
      wmsZeroBypass: 'true'
    }, wmsZeroPending?.barcodeValue);

    stampGuidedLog(logEntry, getState());
    const receiving = await submitGatedZeroScan(logEntry);

    setScanPackLoadingState(dispatch, false);

    handleWmsZeroAskResult(dispatch, receiving, wmsZeroPending, wmsZeroPending?.barcodeValue);
  };
}

// Cancel — the packer walked away from the ask without resolving it. `wmsZeroPending` is cleared
// here for the same reason it is cleared on commit: a stale escalation code must never survive
// into a later, unrelated scan.
export function cancelWmsZeroPrompt() {
  return dispatch => {
    dispatch(clearWmsZeroPending());
    dispatch(closePrompt());
  };
}

export function closeProductInstructionsPrompt() {
  return async (dispatch, getState) => {
    const { barcodeValue, currentOrder, currentItem, userInfo, generalSettings, activeBoxIndex } = getStateValues(getState);

    const logData = getByPassLog(userInfo?.name || '', currentOrder);
    attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    await saveLogToStorage(logData);
    addLocalLog(dispatch, logData);

    dispatch(closePrompt());

    const serialScanResult = checkSerialRecordingEnabled(currentItem);
    if (serialScanResult.showPrompt) {
      dispatch(setScanPackPrompt(true, serialScanResult.message, 'serial_scan', '', false));
      return;
    }

    dispatch(processItemScan(barcodeValue || ''));
  };
}

export function submitKitConfirmation() {
  return (dispatch, getState) => {
    const { prompt, userInfo, generalSettings } = getStateValues(getState);
    const { isMatch, isEmpty, allowBypass } = validateConfirmationCode(
      prompt.input,
      userInfo?.confirmation_code,
      generalSettings?.strict_cc
    );
    if (isMatch || (isEmpty && allowBypass)) {
      dispatch(closePrompt());
    } else {
      dispatch(setScanPackPrompt(true, prompt.message, 'kit_confirmation', '', true));
      playNotReadyFeedback(getState);
    }
  };
}

export function closeKitConfirmation() {
  return (dispatch) => {
    dispatch(closePrompt());
  };
}

export function submitRestartOrder() {
  return async (dispatch, getState) => {
    const { currentOrder, scanPackSettings, generalSettings, activeBoxIndex, userInfo } = getStateValues(getState);

    if (!currentOrder?.id || !scanPackSettings?.restart_code) return;

    const logData = getRestartLog(
      currentOrder,
      scanPackSettings,
      userInfo?.name || ''
    );

    attachBoxIdToLog(logData, currentOrder, activeBoxIndex, generalSettings);
    stampGuidedLog(logData, getState());

    await saveLogToStorage(logData);
    addLocalLog(dispatch, logData);
    resetSubmitLogThrottle();
    await submitQueuedLogsBounded(dispatch);

    const navSource = getState().scanPackScanning.navigationSource;
    dispatch(reset());
    dispatch(closePrompt());
    navigateBack(getState, navSource);
  };
}

export function exitUnscannableOrder(scanPackParams) {
  return (dispatch, getState) => {
    const navSource = getState().scanPackScanning.navigationSource;
    dispatch(reset());
    dispatch(closePrompt());
    navigateBack(getState, navSource, scanPackParams);
  };
}

export function closeServiceIssuePrompt() {
  return (dispatch, getState) => {
    dispatch(closePrompt());
    navigateBack(getState);
  };
}


const handleScanSuccessFeedback = async (dispatch, getState) => {
  const scanPackSettings = scanPackSettingsFrom(getState);
  if (showsSuccessImage(scanPackSettings)) {
    dispatch(setScanPackScanSuccess(true, getSuccessTimeout(scanPackSettings)));
  }
  await playSuccessFeedback(getState);
  dispatch(handleInputFocus());
};

const handleScanErrorFeedback = async (dispatch, getState) => {
  const scanPackSettings = scanPackSettingsFrom(getState);
  if (showsFailImage(scanPackSettings)) {
    dispatch(setScanPackScanError(true, getFailTimeout(scanPackSettings)));
  }
  await playErrorFeedback(getState);
  dispatch(handleInputFocus());
};

const completeSerialScan = async (dispatch, getState, temp, localLog) => {
  const { barcodeValue, scanPackSettings } = getStateValues(getState);
  await saveLogToStorage(temp);
  addLocalLog(dispatch, localLog);
  dispatch(closePrompt());
  const scannedBarcode = barcodeValue || '';
  const processedBarcode = scannedBarcode ? processBarcodeInput(scannedBarcode, scanPackSettings, false) : '';
  dispatch(processItemScan(processedBarcode, true, null, false, scannedBarcode));
};
